/* ============================================================
   WILD YAM — Offer selector custom element <wy-offer>
   Left card = single pouch (qty 1). Right card = duo bundle (qty 1).
   ============================================================ */
(function () {
  'use strict';
  if (customElements.get('wy-offer')) return;

  class WyOffer extends HTMLElement {
    connectedCallback() {
      this.singleVariantId = this.getAttribute('data-single-variant-id') || this.getAttribute('data-variant-id');
      this.duoVariantId = this.getAttribute('data-duo-variant-id');
      this.inputs = this.querySelectorAll('.wy-offer-card__input');
      this.cards = this.querySelectorAll('[data-wy-card]');
      this.media = this.querySelectorAll('[data-wy-media]');
      this.addBtn = this.querySelector('[data-wy-add]');
      this.addText = this.querySelector('[data-wy-add-text]');
      this.spinner = this.querySelector('.wy-offer__spinner');
      this.incremental = this.querySelector('[data-wy-incremental]');
      this.errorBox = this.querySelector('.wy-offer__error');
      this.errorText = this.querySelector('.wy-offer__error-text');

      this.choice = this.getAttribute('data-default') || '2';

      this.inputs.forEach(function (input) {
        input.addEventListener('change', this.onChange.bind(this));
      }, this);

      if (this.addBtn) {
        this.addBtn.addEventListener('click', this.onAdd.bind(this));
      }

      this.render();
    }

    onChange(e) {
      this.choice = e.target.value;
      this.render();
    }

    render() {
      var choice = this.choice;
      this.cards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-wy-card') === choice);
      });
      var syncMedia = function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-wy-media') === choice);
      };
      this.media.forEach(syncMedia);
      var block = this.closest('.wy-offerblock');
      if (block) {
        block.querySelectorAll('[data-wy-media]').forEach(syncMedia);
      }
      if (this.incremental) {
        this.incremental.hidden = choice !== '1';
      }
      if (this.addBtn && this.addText) {
        var label = this.addBtn.getAttribute('data-label-' + choice);
        if (label) this.addText.textContent = label;
      }
    }

    getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    setLoading(state) {
      if (!this.addBtn) return;
      this.addBtn.classList.toggle('is-loading', state);
      this.addBtn.setAttribute('aria-busy', state ? 'true' : 'false');
      this.addBtn.disabled = state;
      if (this.spinner) this.spinner.hidden = !state;
    }

    showError(message) {
      if (!this.errorBox) return;
      this.errorText.textContent = message || 'Something went wrong. Please try again.';
      this.errorBox.hidden = false;
    }

    clearError() {
      if (this.errorBox) this.errorBox.hidden = true;
    }

    buildLineItem() {
      var singleId = Number(this.singleVariantId);
      var duoId = this.duoVariantId ? Number(this.duoVariantId) : null;

      if (this.getAttribute('data-mode') === 'duo_only') {
        return { id: singleId, quantity: 1 };
      }

      if (this.choice === '1') {
        return { id: singleId, quantity: 1 };
      }

      if (duoId && duoId !== singleId) {
        return { id: duoId, quantity: 1 };
      }

      if (duoId && duoId === singleId) {
        return { id: duoId, quantity: 1 };
      }

      return { id: singleId, quantity: 2 };
    }

    onAdd() {
      if (!this.singleVariantId) {
        this.showError('This product is not available right now.');
        return;
      }
      this.clearError();
      this.setLoading(true);

      var cart = this.getCart();
      if (cart && typeof cart.open === 'function' && !cart.classList.contains('active')) {
        cart.open(this.addBtn);
      }

      var sections = (cart && typeof cart.getSectionsToRender === 'function')
        ? cart.getSectionsToRender().map(function (s) { return s.id; })
        : [];

      var lineItem = this.buildLineItem();

      var formData = new FormData();
      formData.append('id', lineItem.id);
      formData.append('quantity', lineItem.quantity);
      if (cart && sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function' && document.activeElement) {
          cart.setActiveElement(document.activeElement);
        }
      }

      var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      var self = this;
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) {
            self.showError(data.description || data.message);
            self.setLoading(false);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wy-offer', cartData: data });
          }
          if (cart) {
            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            if (typeof cart.renderContents === 'function' && data.sections) {
              cart.renderContents(data);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          document.dispatchEvent(new CustomEvent('wy:offer:added', {
            detail: { quantity: lineItem.quantity, choice: self.choice, variantId: lineItem.id }
          }));
          self.setLoading(false);
        })
        .catch(function () {
          self.showError('Network error. Please try again.');
          self.setLoading(false);
        });
    }
  }

  customElements.define('wy-offer', WyOffer);
})();
